/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PresentingConcernSectionResponseDto
 */
export interface PresentingConcernSectionResponseDto {
    /**
     * Unique identifier for this section
     * @type {string}
     * @memberof PresentingConcernSectionResponseDto
     */
    id: string;
    /**
     * Primary health concerns text field
     * @type {string}
     * @memberof PresentingConcernSectionResponseDto
     */
    primaryHealthConcerns: string;
    /**
     * When did you first notice? text field
     * @type {string}
     * @memberof PresentingConcernSectionResponseDto
     */
    whenFirstNoticed?: string;
    /**
     * Treatments tried text field
     * @type {string}
     * @memberof PresentingConcernSectionResponseDto
     */
    treatmentsTried?: string;
}

/**
 * Check if a given object implements the PresentingConcernSectionResponseDto interface.
 */
export function instanceOfPresentingConcernSectionResponseDto(value: object): value is PresentingConcernSectionResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('primaryHealthConcerns' in value) || value['primaryHealthConcerns'] === undefined) return false;
    return true;
}

export function PresentingConcernSectionResponseDtoFromJSON(json: any): PresentingConcernSectionResponseDto {
    return PresentingConcernSectionResponseDtoFromJSONTyped(json, false);
}

export function PresentingConcernSectionResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PresentingConcernSectionResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'primaryHealthConcerns': json['primaryHealthConcerns'],
        'whenFirstNoticed': json['whenFirstNoticed'] == null ? undefined : json['whenFirstNoticed'],
        'treatmentsTried': json['treatmentsTried'] == null ? undefined : json['treatmentsTried'],
    };
}

export function PresentingConcernSectionResponseDtoToJSON(json: any): PresentingConcernSectionResponseDto {
    return PresentingConcernSectionResponseDtoToJSONTyped(json, false);
}

export function PresentingConcernSectionResponseDtoToJSONTyped(value?: PresentingConcernSectionResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'primaryHealthConcerns': value['primaryHealthConcerns'],
        'whenFirstNoticed': value['whenFirstNoticed'],
        'treatmentsTried': value['treatmentsTried'],
    };
}

